module.exports = __webpack_public_path__ + "static/media/secretblogdemo.ed7f1051.png";